import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import useUser from '../hooks/useUser';
import { fetchCategoryMasters, setSelectedClient, resetFilters, selectClients, selectSelectedClient, selectLoading } from '../store/slices/categoryReportsSlice';
import './CategoryMaster.css';

const CategorymastersHeader = () => {
    const dispatch = useDispatch();
    const clients = useSelector(selectClients);
    const selectedClient = useSelector(selectSelectedClient);
    const loading = useSelector(selectLoading);

    const { userRole, userClient } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    const isGspos = roleLower === 'gspos';

    useEffect(() => {
        dispatch(fetchCategoryMasters({
            rolename: localStorage.getItem('role') || '',
            clientname: localStorage.getItem('clientid') || ''
        }));
    }, [dispatch]);

    // Non-gspos roles don't get a client picker — lock the table onto their own
    // client as soon as the clients list (and therefore the matching object) is available.
    useEffect(() => {
        if (isGspos || selectedClient || !clients.length) return;
        const ownClientId = userClient || localStorage.getItem('clientid') || '';
        const ownClient = clients.find((c) => String(c.client_id) === String(ownClientId));
        if (ownClient) dispatch(setSelectedClient(ownClient));
    }, [isGspos, clients, selectedClient, userClient, dispatch]);

    const handleApplyFilters = () => {
        dispatch(fetchCategoryMasters({
            rolename: localStorage.getItem('role') || '',
            clientname: selectedClient?.client_id || localStorage.getItem('clientid') || ''
        }));
    };

    const handleResetFilters = () => {
        dispatch(resetFilters());
        dispatch(fetchCategoryMasters({
            rolename: localStorage.getItem('role') || '',
            clientname: localStorage.getItem('clientid') || ''
        }));
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Category Masters
                </h2>
                <p className="text-color-secondary">View and manage category master records filtered by client</p>
            </div>

            {isGspos && (
                <Card className="mb-4 bill-reports-filter-card">
                    <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                        <div className="flex flex-column" style={{ flex: '1 1 240px', minWidth: '240px' }}>
                            <label htmlFor="client" className="mb-2 font-medium text-sm">
                                Client
                            </label>
                            <Dropdown
                                id="client"
                                value={selectedClient}
                                options={clients}
                                onChange={(e) => dispatch(setSelectedClient(e.value))}
                                optionLabel="client_name"
                                placeholder="Select Client"
                                className="w-full"
                                filter
                                showClear
                            />
                        </div>

                        <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                            <Button label="Apply Filters" icon="pi pi-check" className="p-button-primary" onClick={handleApplyFilters} disabled={loading} loading={loading} />
                            <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleResetFilters} />
                        </div>
                    </div>
                </Card>
            )}
        </>
    );
};

export default CategorymastersHeader;
